var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wc-row mobileImageTop"},[_c('div',{staticClass:"form-div wc-col-no-padding wc-col-no-padding__sm-6 wc-col-no-padding__md-6"},[_vm._t("component")],2),_c('div',{staticClass:"image-div wc-col-no-padding wc-col-no-padding__sm-6 wc-col-no-padding__md-6"},[_c('KeyVisualAccount')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }